import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  commingSoon,
  getTabStatus,
  goToClientDashboard,
  handleDownloadDocument,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import suspa from "../../../asset/images/suspa.svg";
import againgalert from "../../../asset/images/againgalert.svg";
import mtfalart from "../../../asset/images/mtfalart.svg";
import daysalart from "../../../asset/images/daysalart.svg";
import { Modal } from "react-bootstrap";
import LoaderForSearch from "../../Common/LoaderForSearch";
import SmallLoader from "../../Common/smallLoader";
import axios from "axios";
import { toast } from "react-toastify";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { useRef } from "react";
const reportConfigs = {
  cuspa: {
    url: DASHBOARD_DEFAULT.CuspaReportDetails,
    key: "cuspa",
  },
  ageing: {
    url: DASHBOARD_DEFAULT.AgeingReportDetails,
    key: "ageing",
  },
  mtfShortfall: {
    url: DASHBOARD_DEFAULT.MtfShortFallReportDetails,
    key: "mtfShortfall",
  },
  thirtyDays: {
    url: DASHBOARD_DEFAULT.ThirtyDaysAgeingDetails,
    key: "thirtyDays",
  },
};
function RmsAlert() {
  const [showModal, setShowModal] = useState(false);
  const [showModalAgain, setShowModalAgain] = useState(false);
  const [showModalMtf, setShowModalMtf] = useState(false);
  const [showModalAlart, setShowModalAlart] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const storeToken = localStorage.getItem("ssoToken");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [fileType, setFileType] = useState("grid");
  const [activeClientInfo, setActiveClientInfo] = useState([]);
  const [againAlart, setAgainAlart] = useState([]);
  const [mtfShortData, setMtfShortData] = useState([]);
  const [daysAgainData, setDaysAgainData] = useState([]);
  const [endpoint, setEndpoint] = useState(null);
  const [excelDow, setExcelDow] = useState(null);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [loaderMap, setLoaderMap] = useState({
    cuspa: false,
    ageing: false,
    mtfShortfall: false,
    thirtyDays: false,
  });
  const controllerRef = useRef(null);

  const resetAllLoaders = () => {
    setLoaderMap({
      cuspa: false,
      ageing: false,
      mtfShortfall: false,
      thirtyDays: false,
    });
  };

  const setSingleLoader = (key, value) => {
    setLoaderMap((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleViewClick = (config) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    setFileType("grid");
    resetAllLoaders();
    setSingleLoader(config.key, true);
    setExcelDow(config.key);
    setEndpoint(config.url);
    setPage(1);
    setPageSize(10);
    getRmsInfoData(config.url, config.key, 10, "grid");
  };

  useEffect(() => {
    if (page > 1 && fileType === "grid" && endpoint) {
      getRmsInfoData(endpoint);
    }
  }, [page]);

  const getRmsInfoData = async (endpoint, key, passedPageSize = pageSize, passedFileType = fileType) => {
    const thisController = new AbortController();
    controllerRef.current = thisController;
    console.log("New controller created");

    if (passedFileType == "excel") {
      setSmallLoaderExcel(true);
      setScrollLoader(false);
    } else if (passedFileType == "pdf") {
      setSmallLoaderExcel(false);
    } else {
      setSmallLoaderExcel(false);
    }

    let payloadValue = {
      pageSize: passedPageSize,
      pageNo: page,
      fileType: passedFileType,
    };
    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getActiveInFo = await axios.post(endpoint, `"${encPayload}"`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storeToken}`,
          reserv: 1,
        },
        signal: controllerRef.current.signal,
      });
      let response = ApiResDecrypt(getActiveInFo?.data);
      const res = response.data;
      console.log(res, "res");
      setCount(res?.totalCounts);
      if (
        (res.cuspaDetails == undefined && excelDow == "cuspa") ||
        (res.ageingDetails == undefined && excelDow == "ageing") ||
        (res.mtfshortfallDetails == undefined && excelDow == "mtfShortfall") ||
        (res.ageingDetails == undefined && excelDow == "thirtyDays")
      ) {
        if (passedFileType == "excel") {
          handleDownloadDocument(res);
        }
      }
      if (res?.cuspaDetails) {
        setShowModal(true);
        setShowModalAlart(false);
        setShowModalAgain(false);
        setShowModalMtf(false);
        if (showModal === true) {
          if (passedFileType === "grid") {
            if(page > 1){
            setActiveClientInfo((prev) => {
              return [...prev, ...res?.cuspaDetails];
            });
          }else{
            setActiveClientInfo(res?.cuspaDetails);
          }
          } else if (passedFileType === "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } 
        else {
          setActiveClientInfo(res?.cuspaDetails);
        }
      }
      if (res?.ageingAlertDetails) {
        setShowModalAgain(true);
        setShowModal(false);
        setShowModalMtf(false);
        setShowModalAlart(false);
        if (showModalAgain == true) {
          if (passedFileType == "grid") {
            if(page > 1){
            setAgainAlart((prev) => {
              return [...prev, ...res.ageingAlertDetails];
            });
          }else{
            setAgainAlart(res.ageingAlertDetails)
          }
          } else if (passedFileType == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } 
        else {
          setAgainAlart(res.ageingAlertDetails);
        }
      }
      if (res.mtfshortfallDetails) {
        setShowModalMtf(true);
        setShowModalAgain(false);
        setShowModal(false);
        setShowModalAlart(false);
        if (showModalMtf == true) {
          if (passedFileType == "grid") {
            if(page > 1){
            setMtfShortData((prev) => {
              return [...prev, ...res.mtfshortfallDetails];
            });
          }else{
            setMtfShortData(res.mtfshortfallDetails);
          }
          } else if (passedFileType == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          setMtfShortData(res.mtfshortfallDetails);
        }
      }
      if (res?.ageingDetails) {
        setShowModalAlart(true);
        setShowModalMtf(false);
        setShowModalAgain(false);
        setShowModal(false);
        if (showModalAlart == true) {
          if (passedFileType == "grid") {
            if(page > 1){
            setDaysAgainData((prev) => {
              return [...prev, ...res.ageingDetails];
            });
          }else{
            setDaysAgainData(res?.ageingDetails);
          }
          } else if (passedFileType == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          setDaysAgainData(res?.ageingDetails);
        }
      }
      //  else {
      //   setSmallLoaderExcel(false);
      //   setScrollLoader(false);
      // }
      if (response.status == 1) {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      // setSmallLoaderExcel(false);
      // setScrollLoader(false);
      setServerError("Something went wrong, Please try again later.");
      if (passedFileType == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (passedFileType == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    } finally {
      if (!thisController.signal.aborted) {
        setSingleLoader(key, false);
      }
      setScrollLoader(false);
      setSmallLoaderExcel(false);
      setIsApiLoading(false);
    }
  };
  const showModalActiveData = (activeClientInfo) => {
    return (
      activeClientInfo &&
      activeClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  getTabStatus("");
                }}
              >
                {checkEmpty(info.clientCode) ? "-" : info.clientCode}
              </a>
            </td>
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>
            {/* <td>{checkEmpty(info.processDate) ? "-" : info.processDate}</td> */}
            <td>{checkEmpty(info.symbol) ? "-" : info.symbol}</td>
            <td>{checkEmpty(info.series) ? "-" : info.series}</td>
            <td>{checkEmpty(info.bseCode) ? "-" : info.bseCode}</td>
            <td>{checkEmpty(info.scripName) ? "-" : info.scripName}</td>
            <td>{checkEmpty(info.isin) ? "-" : info.isin}</td>
            <td>{checkEmpty(info.qty) ? "-" : info.qty}</td>
            <td>{checkEmpty(info.noOfDays) ? "-" : info.noOfDays}</td>
            <td>{checkEmpty(info.settNo) ? "-" : info.settNo}</td>
            <td>{checkEmpty(info.branchCode) ? "-" : info.branchCode}</td>
            <td>{checkEmpty(info.rate) ? "-" : info.rate}</td>
            <td>{checkEmpty(info.amt) ? "-" : info.amt}</td>
            <td>{checkEmpty(info.vdt) ? "-" : info.vdt}</td>
            <td>{checkEmpty(info.edt) ? "-" : info.edt}</td>
            <td>
              {checkEmpty(info.unSettledValue) ? "-" : info.unSettledValue}
            </td>
            <td>{checkEmpty(info.sellingDate) ? "-" : info.sellingDate}</td>
            {/* <td>{checkEmpty(info.mName) ? "-" : info.mName}</td>
            <td style={{ paddingRight: "20px" }}>
              {checkEmpty(info.rmEmail) ? "-" : info.rmEmail}
            </td> */}
          </tr>
        );
      })
    );
  };
  const showModalAgainData = (againAlart) => {
    return (
      againAlart &&
      againAlart.map((info, key) => {
        return (
          <tr key={key}>
            <td>{checkEmpty(info.clientCode) ? "-" : info.clientCode}</td>
            <td>{checkEmpty(info.branchCode) ? "-" : info.branchCode}</td>
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>
            <td>{checkEmpty(info.balance) ? "-" : info.balance}</td>
            <td>
              <a
              // onClick={() => {
              //     goToClientDashboard(info.clientCode, "");
              //     getTabStatus("")
              // }}
              >
                {checkEmpty(info.ageBalance) ? "-" : info.ageBalance}
              </a>
            </td>
            <td>{checkEmpty(info.ageDays) ? "-" : info.ageDays}</td>
            <td>{checkEmpty(info.isholding) ? "-" : info.isholding}</td>
            {/* <td>{checkEmpty(info.mName) ? "-" : info.mName}</td>
            <td>{checkEmpty(info.processDate) ? "-" : info.processDate}</td>
            <td>{checkEmpty(info.rmEmail) ? "-" : info.rmEmail}</td> */}
            <td>{checkEmpty(info.sellingDate) ? "-" : info.sellingDate}</td>
            <td style={{ paddingRight: "20px" }}>
              {checkEmpty(info.totalBalance) ? "-" : info.totalBalance}
            </td>
          </tr>
        );
      })
    );
  };

  const showModalTableMtf = (mtfShortData) => {
    return (
      mtfShortData &&
      mtfShortData.map((info, key) => {
        return (
          <tr key={key}>
            <td>{checkEmpty(info.clientCode) ? "-" : info.clientCode}</td>
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>
            <td>{checkEmpty(info.branchCD) ? "-" : info.branchCD}</td>
            <td>
              <a
              // onClick={() => {
              //     goToClientDashboard(info.clientCode, "");
              //     getTabStatus("")
              // }}
              >
                {checkEmpty(info.availableCash) ? "-" : info.availableCash}
              </a>
            </td>

            <td>{checkEmpty(info.collateralAHC) ? "-" : info.collateralAHC}</td>
            <td>{checkEmpty(info.collateralBHC) ? "-" : info.collateralBHC}</td>
            <td>{checkEmpty(info.fudedVal) ? "-" : info.fudedVal}</td>
            <td>{checkEmpty(info.fudedValAFM) ? "-" : info.fudedValAFM}</td>
            <td>{checkEmpty(info.marginReq) ? "-" : info.marginReq}</td>
            <td>
              {checkEmpty(info.marginShortFall) ? "-" : info.marginShortFall}
            </td>
            <td>{checkEmpty(info.mtfLedBAL) ? "-" : info.mtfLedBAL}</td>
            <td>{checkEmpty(info.mtom) ? "-" : info.mtom}</td>
            <td>{checkEmpty(info.noOfAgingDays) ? "-" : info.noOfAgingDays}</td>
            <td>{checkEmpty(info.rmEmail) ? "-" : info.rmEmail}</td>
            <td>{checkEmpty(info.rmName) ? "-" : info.rmName}</td>
            <td>{checkEmpty(info.shortFall) ? "-" : info.shortFall}</td>
            <td>{checkEmpty(info.subBroker) ? "-" : info.subBroker}</td>
            <td style={{ paddingRight: "20px" }}>
              {checkEmpty(info.tradeDate) ? "-" : info.tradeDate}
            </td>
          </tr>
        );
      })
    );
  };
  const showModalTablAgainAlart = (daysAgainData) => {
    return (
      daysAgainData &&
      daysAgainData.map((info, key) => {
        return (
          <tr key={key}>
            <td>{checkEmpty(info.client) ? "-" : info.client}</td>
            <td>{checkEmpty(info.clientName) ? "-" : info.clientName}</td>
            <td>{checkEmpty(info.branch) ? "-" : info.branch}</td>
            <td>{checkEmpty(info.name) ? "-" : info.name}</td>
            <td>
              <a
              // onClick={() => {
              //     goToClientDashboard(info.clientCode, "");
              //     getTabStatus("")
              // }}
              >
                {checkEmpty(info.aboveOneHundTwentyOne)
                  ? "-"
                  : info.aboveOneHundTwentyOne}
              </a>
            </td>
            <td>{checkEmpty(info.balance) ? "-" : info.balance}</td>
            <td>{checkEmpty(info.drcr) ? "-" : info.drcr}</td>
            <td>
              {checkEmpty(info.fiftyOne_Ninety) ? "-" : info.fiftyOne_Ninety}
            </td>
            <td>{checkEmpty(info.holdings) ? "-" : info.holdings}</td>
            <td>{checkEmpty(info.netTotal) ? "-" : info.netTotal}</td>
            <td>
              {checkEmpty(info.ninetyOne_OneHundTwenty)
                ? "-"
                : info.ninetyOne_OneHundTwenty}
            </td>
            <td>
              {checkEmpty(info.thirtyOne_Fifty) ? "-" : info.thirtyOne_Fifty}
            </td>
            <td>
              {checkEmpty(info.twentyOne_Thirty) ? "-" : info.twentyOne_Thirty}
            </td>
            <td style={{ paddingRight: "20px" }}>
              {checkEmpty(info.zero_Twenty) ? "-" : info.zero_Twenty}
            </td>
          </tr>
        );
      })
    );
  };

  const onHide = () => {
    if (showModal == true) {
      setShowModal(false);
    }
    if (showModalAgain == true) {
      setShowModalAgain(false);
    }
    if (showModalMtf == true) {
      setShowModalMtf(false);
    }
    if (showModalAlart == true) {
      setShowModalAlart(false);
    }
    setPage(1);
  };

  const handleFileType = (e) => {
    const selectedType = e.target.value;

  if (!selectedType) return;
      setIsApiLoading(true);  
      setFileType(selectedType);
      setPageSize(-1);
      if ((selectedType === "excel" || selectedType === "pdf") && endpoint) {
        getRmsInfoData(endpoint, excelDow, -1, selectedType, );
      }
  };
  // const handleScroll = (e) => {
  //   setFileType("grid");
  //   if (
  //     showModal == true ||
  //     showModalAgain == true ||
  //     showModalMtf == true ||
  //     showModalAlart == true
  //   ) {
  //     setPageSize(10);
  //     const a = document.querySelector("#abcd1");
  //     if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
  //       // if (count <= pageSize * page) {
  //       //   setScrollLoader(false);
  //       //   return;
  //       }
  //       if (!(count <= 10 * page) && count !== "undefined") {
  //         console.log("pageIncresed");
  //         setScrollLoader(true);
  //         setPage((prev) => prev + 1);
  //       }
      
  //       console.log(endpoint,count, "endpoint");
  //       // if (
  //       //   endpoint && count !== "undefined" &&
  //       //   (showModal || showModalAgain || showModalMtf || showModalAlart)
  //       // ) {
  //       //   setPage((prev) => prev + 1);
  //       //   setScrollLoader(true);
  //       // }
  //     // }
  //   } else {
  //     setPage(1);
  //   }
  // };

  const handleScroll = (e) => {
    if(fileType !== "grid"){
      setFileType("grid");
      setPageSize(10);
    }
    if (
      isApiLoading ||                   
      // fileType !== "grid" ||            
      !(showModal || showModalAgain || showModalMtf || showModalAlart)
    ) {
      return;
    }
  
    const a = document.querySelector("#abcd1");
    if (
      a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight &&
      !scrollLoader
    ) {

      const totalPages = Math.ceil(count / pageSize);
      console.log(count, count <= 10 * page, "totalPages");
      if (!(count <= 10 * page)) {
        setScrollLoader(true);
        setPage((prev) => prev + 1);
      }
    

    // if (page < totalPages) {
    //   setScrollLoader(true);
    //   setPage((prev) => prev + 1);
    // } else {
    //   console.log("✅ All data loaded");
    // }
  };
}

  return (
    <>
      <div className="block1 alert-table">
        <div className="card-title">
          <h2>RMS Alert</h2>
        </div>
        <div className="rms-main-body">
          <div className="rms-card-wrap">
            <div
              className="rms-small-card"
              onClick={() => handleViewClick(reportConfigs.cuspa)}
            >
              <img src={suspa} alt="suspa" />
              <div className="wrap-card-name">
                <span className="rms-card-title">CUSPA Alert</span>
                {loaderMap.cuspa && <SmallLoader />}
              </div>
            </div>
            <div
              className="rms-small-card"
              onClick={() => handleViewClick(reportConfigs.ageing)}
            >
              <img src={againgalert} alt="suspa" />
              <div className="wrap-card-name">
                <span className="rms-card-title">Ageing Alert</span>
                {loaderMap.ageing && <SmallLoader />}
              </div>
            </div>
          </div>
          <div className="rms-card-wrap">
            <div
              className="rms-small-card"
              onClick={() => handleViewClick(reportConfigs.mtfShortfall)}
            >
              <img src={mtfalart} alt="suspa" />
              <div className="wrap-card-name">
                <span className="rms-card-title">MTF Short Fall Alert</span>
                {loaderMap.mtfShortfall && <SmallLoader />}
              </div>
            </div>
            <div
              className="rms-small-card"
              onClick={() => handleViewClick(reportConfigs.thirtyDays)}
            >
              <img src={daysalart} alt="suspa" />
              <div className="wrap-card-name">
                <span className="rms-card-title">30+ days Ageing Alert</span>
                {loaderMap.thirtyDays && <SmallLoader />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">CUSPA Alert</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table rms-table">
            <table className="table">
              <thead style={{ width: "2000px" }}>
                <tr style={{ width: "2000px" }}>
                  <th>Client Code</th>
                  <th>Client Name</th>
                  {/* <th>Process Date</th> */}
                  <th>Symbol</th>
                  <th>Series</th>
                  <th>BSE Code</th>
                  <th>Scrip Name</th>
                  <th>ISIN</th>
                  <th>QUINTITY</th>
                  <th>No Of Days</th>
                  <th>SettNo</th>
                  <th>Branch Code</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>VTD</th>
                  <th>ETD</th>
                  <th>UN Settled Value</th>
                  <th>Selling Date</th>
                  {/* <th>M Name</th> */}
                  {/* <th style={{ paddingRight: "20px" }}>RM Email</th> */}
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalActiveData(activeClientInfo)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            {/* <button
                            className="generate-btn txt-purple"
                            // onClick={handleFileType}
                            value="pdf"
                        >
                            {smallLoaderPdf ? (
                                <SmallLoader />
                            ) : (
                                <>
                                    <span className="icon-pdfsvg"></span> {"PDF"}
                                </>
                            )}
                        </button> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalAgain}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">Ageing Alert</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            <table className="table">
              <thead style={{ width: "1300px" }}>
                <tr style={{ width: "1300px" }}>
                  <th>Client Code</th>
                  <th>Branch Code</th>
                  <th>Client Name</th>
                  <th>Balance</th>
                  <th>Age Balance</th>
                  <th>Age Days</th>
                  <th>Holding</th>
                  {/* <th>Name</th> */}
                  {/* <th>Process Date</th> */}
                  {/* <th>RM Email</th> */}
                  <th>Selling Date</th>
                  <th style={{ paddingRight: "20px" }}>Total Balance</th>
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalAgainData(againAlart)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            {/* <button
                            className="generate-btn txt-purple"
                            // onClick={handleFileType}
                            value="pdf"
                        >
                            {smallLoaderPdf ? (
                                <SmallLoader />
                            ) : (
                                <>
                                    <span className="icon-pdfsvg"></span> {"PDF"}
                                </>
                            )}
                        </button> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalMtf}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">MTF Short Fall Alert</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            <table className="table">
              <thead style={{ width: "2000px" }}>
                <tr style={{ width: "2000px" }}>
                  <th>Client Code</th>
                  <th>Client Name</th>
                  <th>Branch CD</th>
                  <th>Available Cash</th>
                  <th>Collateral AHC</th>
                  <th>Collateral BHC</th>
                  <th>Fuded Value</th>
                  <th>Fuded Value AFM</th>
                  <th>Margin Req</th>
                  <th>Margin Short Fall</th>
                  <th>MTF Led BAL</th>
                  <th>M Tom</th>
                  <th>No Of Aging Days</th>
                  <th>RM Email</th>
                  <th>RM Name</th>
                  <th>Short Fall</th>
                  <th>Sub Broker</th>
                  <th style={{ paddingRight: "20px" }}>Trade Date</th>
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalTableMtf(mtfShortData)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            {/* <button
                            className="generate-btn txt-purple"
                            // onClick={handleFileType}
                            value="pdf"
                        >
                            {smallLoaderPdf ? (
                                <SmallLoader />
                            ) : (
                                <>
                                    <span className="icon-pdfsvg"></span> {"PDF"}
                                </>
                            )}
                        </button> */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalAlart}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">30+ days Ageing Alert</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            <table className="table">
              <thead style={{ width: "1800px" }}>
                <tr style={{ width: "1800px" }}>
                  <th>Client Code</th>
                  <th>Client Name</th>
                  <th>Branch</th>
                  <th>Name</th>
                  <th>Above one 100</th>
                  <th>Balance</th>
                  <th>Drcr</th>
                  <th>Fifty One Ninety</th>
                  <th>Holdings</th>
                  <th>Net Total</th>
                  <th>Ninety One OneHundTwenty</th>
                  <th>Thirty One Fifty</th>
                  <th>Twenty One Thirty</th>
                  <th style={{ paddingRight: "20px" }}>Zero Twenty</th>
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalTablAgainAlart(daysAgainData)}
                {scrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={handleFileType}
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RmsAlert;
